<template>
  <div>
    <div class="viewport viewport-with-bottom-nav viewport-compact">

      <div class="display-1 my-3">{{ $t('Contacts.title') }}</div>

      <p>{{ $t('Contacts.businessHours') }}</p>

      <div class="list-group list-group-escape-container mb-4">
        <div v-for="(contact, index) in contacts" :key="index" class="list-group-item contacts">
          <div class="d-flex">
            <Icon :icon-name="contact.icon" icon-class="text-primary mr-3"></Icon>
            <div class="d-flex justify-content-between flex-grow-1">
              <div v-html="$t(`Contacts.${contact.label}`)"/>
              <a :href="contact.url">{{ contact.text }}</a>
            </div>
          </div>
        </div>
        <a v-if="chatEnabled" href class="list-group-item list-group-item-action" @click.prevent="chatClicked">
          <div class="d-flex">
            <Icon :icon-name="'message-square-outline'" icon-class="text-primary mr-3"></Icon>
            <div class="d-flex justify-content-between flex-grow-1">
              <div v-html="$t(`Contacts.chat`)"/>
              <Icon icon-name="chat" icon-class="text-primary mr-3"></Icon>
            </div>
          </div>
        </a>
      </div>

      <h6 class="card-title mb-3">{{ $t('Contacts.findUs') }}</h6>

      <div class="list-group list-group-escape-container mb-4">
        <router-link :to="{ name: 'branches' }" class="list-group-item list-group-item-action">
          <div class="d-flex">
            <Icon icon-name="pin-outline" icon-class="text-primary mr-3"></Icon>
            <div class="flex-grow-1">{{ $t('Contacts.branches') }}</div>
            <Icon icon-name="arrow-ios-forward-outline" icon-class="text-muted-more mr-n2"></Icon>
          </div>
        </router-link>
        <router-link v-if="showPartners" :to="{ name: 'partners' }" class="list-group-item list-group-item-action">
          <div class="d-flex">
            <Icon icon-name="pin-outline" icon-class="text-primary mr-3"></Icon>
            <div class="flex-grow-1">{{ $t('Contacts.partners') }}</div>
            <Icon icon-name="arrow-ios-forward-outline" icon-class="text-muted-more mr-n2"></Icon>
          </div>
        </router-link>
      </div>

      <h6 class="card-title mb-3">{{ $t('Contacts.followUs') }}</h6>

      <div class="list-group list-group-escape-container">
        <div v-for="(social, index) in socials" :key="index" class="list-group-item socials">
          <div class="d-flex">
            <Icon :icon-name="social.icon" icon-class="text-primary mr-3"></Icon>
            <div class="flex-grow-1">{{ $t(`Contacts.${social.label}`) }}</div>
            <a :href="social.url" target="_blank">{{ social.text }}</a>
          </div>
        </div>
      </div>

      <div class="flex-grow-1"></div>

      <DevelopmentInformation v-if="showDevelopmentDetails"/>
      <BottomNav></BottomNav>

    </div>
  </div>
</template>
<script>
import store from '@shared/store'
import settings from '@shared/settings'
import chat, { openChat } from '@shared/module/chat'
import Icon from '@shared/components/Icon'
import ContactsMixin from '@/mixins/ContactsMixin'
import BottomNav from '../components/BottomNav'
import PartnersMixin from '@shared/mixins/PartnersMixin'
import DevelopmentInformation from '@shared/components/DevelopmentInformation'

export default {
  name: 'ContactsPage',
  components: { BottomNav, Icon, DevelopmentInformation },
  mixins: [
    ContactsMixin, PartnersMixin
  ],
  data() {
    return {
      chatEnabled: settings.featureFlags.isChatEnabled(),
      store: store.state
    }
  },
  mounted() {
    if (this.chatEnabled && !settings.isDesktopWeb()) chat()
  },
  methods: {
    chatClicked() {
      openChat()
    }
  },
  computed: {
    showPartners() {
      return this.getPartners().length > 0
    },
    showDevelopmentDetails() {
      return settings.isTestMode()
    }
  }
}
</script>
